export const keys = Object.keys.bind(Object) as typeof Object.keys;
export const values = Object.values.bind(Object) as typeof Object.values;
export const entries = Object.entries.bind(Object) as typeof Object.entries;
